export const FAST_SCAN_BADGE = 'FAST_SCAN_BADGE'
export const FAST_SCAN_BADGE_SUCCEEDED = 'FAST_SCAN_BADGE_SUCCEEDED'
export const FAST_SCAN_BADGE_FAILED = 'FAST_SCAN_BADGE_FAILED'
export const CLEAR_SCANNED_BADGE = 'CLEAR_SCANNED_BADGE'
